// // polyfill
export class DummyStorage {
  constructor() {
    this.length = 0;
  }
  clear() {}
  getItem(_key) {
    return null;
  }
  key(_index) {
    return null;
  }
  removeItem(_key) {}
  setItem(_key, _data) {}
}